import * as React from 'react';
import { Link, StaticQuery } from "gatsby";
import Img from 'gatsby-image';
export var EntryCard = function EntryCard(_ref) {
  var heading = _ref.heading,
      excerpt = _ref.excerpt,
      slug = _ref.slug,
      imagePath = _ref.imagePath,
      readMoreLabel = _ref.readMoreLabel;
  return /*#__PURE__*/React.createElement(StaticQuery, {
    render: function render(data) {
      var image = imagePath && data.allImageSharp.nodes.find(function (item) {
        return imagePath.includes(item.fluid.originalName);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "entry-card"
      }, /*#__PURE__*/React.createElement("h2", null, typeof heading === 'string' ? /*#__PURE__*/React.createElement(Link, {
        className: "no-decorators",
        to: slug
      }, heading) : heading), /*#__PURE__*/React.createElement(Link, {
        className: "no-decorators",
        to: slug
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-container"
      }, image && /*#__PURE__*/React.createElement(Img, {
        fluid: image.fluid
      }))), typeof excerpt === 'string' ? /*#__PURE__*/React.createElement(Link, {
        className: "no-decorators",
        to: slug
      }, /*#__PURE__*/React.createElement("p", null, excerpt)) : excerpt, /*#__PURE__*/React.createElement(Link, {
        className: "read-more",
        to: slug
      }, readMoreLabel || 'Read More→'));
    },
    query: "670206620"
  });
};